import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { TEXTAREA_BASE, LABEL_TEXT } from '../styles/classNames';

/**
 * Редактор заметок с поддержкой Markdown
 * Режимы: Просмотр (рендер Markdown) и Редактирование (textarea)
 */
export function NotesEditor({ 
  value, 
  onChange, 
  disabled = false 
}) {
  const [isEditing, setIsEditing] = useState(false);
  
  return (
    <div className="space-y-2">
      {/* Переключатель режимов */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsEditing(false);
            }}
            disabled={disabled}
            className={`px-3 py-1 text-xs rounded-lg border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
              !isEditing 
                ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400'
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            👁️ Просмотр
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsEditing(true);
            }}
            disabled={disabled}
            className={`px-3 py-1 text-xs rounded-lg border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
              isEditing 
                ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400'
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            ✏️ Редактировать
          </button>
        </div>
        
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {value ? `${value.length} символов` : 'Пусто'}
        </div>
      </div>
      
      {/* Режим просмотра (Markdown рендер) */}
      {!isEditing && (
        <div 
          className={`${TEXTAREA_BASE} min-h-[160px] prose prose-sm dark:prose-invert max-w-none overflow-auto cursor-pointer`}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) setIsEditing(true);
          }}
          title="Нажмите для редактирования"
        >
          {value ? (
            <ReactMarkdown>{value}</ReactMarkdown>
          ) : (
            <div className="text-gray-400 dark:text-gray-600 italic">
              Нажмите "Редактировать" или запишите аудио
            </div>
          )}
        </div>
      )}
      
      {/* Режим редактирования (textarea) */}
      {isEditing && (
        <>
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Коротко о договоренностях, бюджете, GEO, ставках, возражениях
Поддерживается Markdown: **жирный**, *курсив*, [ссылка](url), - список"
            className={`${TEXTAREA_BASE} min-h-[160px]`}
            disabled={disabled}
          />
          <div className="text-xs text-gray-500 dark:text-gray-400 flex justify-between">
            <span>Markdown: **жирный** *курсив* [ссылка](url) ### Заголовок</span>
          </div>
        </>
      )}
    </div>
  );
}
